import { memberApiV2 } from '../lib/api';
import {
  CalendarEventItem,
  GetEvisitEventsParams,
  ICreateEVisitRuleParams,
  IEventsDaysTypes,
  IEVisitEvents,
  IEVisitsRules,
  IGetEventsParams,
  IGetEventsParamsOld,
  IGetEVisitRulesParams,
  IGetOfficeHoursParams,
  IOfficeHours,
  TDeleteEVisitRuleParams,
  TUpdateEVisitRuleParams,
} from '../types/e-visits';

import { IPagination } from 'types/pagination.types';
import { ITagsPaginationArgs, TagItem, TCreateTagData, TUpdateTagData } from '../types/tags-page';

/**
 * Get types of evens for day
 * @param dateFrom date form
 * @param dateTo date to
 * @returns
 */
// TODO: Needs to be done on backend
export function getEVisitsTypesForDay(providerId: string, params: IGetEventsParams) {
  return memberApiV2.customV2<{ data: { dates: IEventsDaysTypes } }>(
    '/e-visit/doctor-orders-days',
    providerId,
    {
      method: 'GET',
      params,
    },
  );
}

/**
 * Get events for selected date range
 * @param dateFrom date form
 * @param dateTo date to
 * @deprecated
 * @returns
 */
// TODO: Delete
export function getEVisitsEventsOld(providerId: string, params: IGetEventsParamsOld) {
  return memberApiV2.customV2<{ data: { dates: IEVisitEvents } }>(
    '/e-visit/doctor-orders',
    providerId,
    {
      method: 'GET',
      params,
    },
  );
}

/**
 * Get office hours for location and expertise
 * @param params params
 * @returns
 */
export function getOfficeHours(providerId: string, params: IGetOfficeHoursParams) {
  return memberApiV2.customV2<{
    data: {
      officeHours: IOfficeHours;
    };
  }>(
    `/client/calendar/workspace/hours/${params.medicalInstitutionId}?expertId=${params.doctorUserId}&year=${params.year}&ISOWeekNumber=${params.ISOWeekNumber}`,
    providerId,
    {
      method: 'GET',
    },
  );
}

/**
 * Cancel e-visit order for patient
 * @param orderId order id
 * @param reason reason of cancellation
 */
export function cancelEVisit(providerId: string, orderId: string, reason: string) {
  return memberApiV2.customV2(
    `/management/private/calendar/order/${orderId}?reson=${reason}`,
    providerId,
    {
      method: 'DELETE',
    },
  );
}

/**
 * Get e-visit rules for expertise, institution and selected time frame
 * @param params params for fetch
 * @returns Promise with records
 */
export function getEVisitRules(providerId: string, params: IGetEVisitRulesParams) {
  const normalizedParams = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    workspaceId: params.medicalInstitutionId,
  };

  return memberApiV2.customV2<{
    timeIntervals: IEVisitsRules;
  }>('/management/private/calendar/time-interval', providerId, {
    method: 'GET',
    params: normalizedParams,
  });
}

/**
 * Create e-visit rule
 * @param rule rule to create
 * @returns promise
 */
export function createEVisitRule(providerId: string, rule: ICreateEVisitRuleParams) {
  return memberApiV2.customV2('/management/private/calendar/time-interval', providerId, {
    method: 'POST',
    data: { ...rule, workspaceId: rule.medicalInstitutionId },
  });
}

/**
 * Update e-visit rule
 * @param rule rule config
 * @returns Promise
 */
export function updateEVisitRule(providerId: string, rule: TUpdateEVisitRuleParams) {
  return memberApiV2.customV2('/management/private/calendar/time-interval', providerId, {
    method: 'PUT',
    data: { ...rule, workspaceId: rule.medicalInstitutionId },
  });
}

/**
 * Delete e-visit rule
 * @param rule rule config
 * @returns Promise
 */
export function deleteEVisitRule(providerId: string, rule: TDeleteEVisitRuleParams) {
  return memberApiV2.customV2('/management/private/calendar/time-interval', providerId, {
    method: 'DELETE',
    data: rule,
  });
}

export function createTagRequest(data: TCreateTagData) {
  return memberApiV2.request('/management/public/calendar/tags', {
    method: 'POST',
    data,
  });
}

export function updateTagRequest({ id, data }: TUpdateTagData) {
  return memberApiV2.request(`/management/public/calendar/tags/${id}`, {
    method: 'PUT',
    data,
  });
}

export function deleteTagRequest(id: string) {
  return memberApiV2.request(`/management/public/calendar/tags/${id}`, {
    method: 'DELETE',
  });
}

export function getTagsWithPagination(paginationArgs: Partial<ITagsPaginationArgs>) {
  return memberApiV2.request<{ data: { tags: TagItem[]; pagination: IPagination } }>(
    `/management/public/calendar/tags`,
    {
      params: paginationArgs,
    },
  );
}

export function getEVisitsEvents(providerId: string, params: GetEvisitEventsParams) {
  return memberApiV2.request<{ data: CalendarEventItem[] }>('/management/private/calendar/events', {
    method: 'GET',
    params,
    headers: {
      'provider-id': providerId,
    },
  });
}
